enum CareersNavId {
  AboutAllTrails = 'about-alltrails',
  OurBenefits = 'our-benefits',
  OpenPositions = 'open-positions'
}

export { CareersNavId };
